import { cn } from "@/common/helpers/utils";
import type { ReactElement, ReactNode } from "react";

export enum CenteredLayoutVariant {
  Form = "form",
  Default = "default",
  Wide = "wide",
  Table = "table",
}

const centeredLayoutVariantClasses = {
  [CenteredLayoutVariant.Form]: "mx-auto w-full max-w-3xl",
  [CenteredLayoutVariant.Default]: "mx-auto w-full max-w-5xl",
  [CenteredLayoutVariant.Wide]: "mx-auto w-full max-w-screen-2xl",
  [CenteredLayoutVariant.Table]: "mx-auto flex-1 min-h-0 w-full max-w-screen-2xl",
} as const satisfies Record<CenteredLayoutVariant, string>;

interface CenteredLayoutProps {
  children: ReactNode;
  className?: string;
  title?: ReactNode;
  subTitle?: string;
  variant?: CenteredLayoutVariant;
}

export function CenteredLayout({
  children,
  className,
  title,
  subTitle,
  variant = CenteredLayoutVariant.Default,
}: CenteredLayoutProps): ReactElement {
  return (
    <section className={cn("flex w-full flex-col gap-3", centeredLayoutVariantClasses[variant], className)}>
      {title && (
        <div className="flex flex-col gap-2">
          {typeof title === "string" ? (
            <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">{title}</h1>
          ) : (
            title
          )}
          {subTitle && <p className="text-muted-foreground text-sm sm:text-base">{subTitle}</p>}
        </div>
      )}
      {children}
    </section>
  );
}
